import { gql } from 'graphql-request'

export const GET_BOOK_COLLECTION_BY_USER_ID = gql`
  query GetBookCollectionsByUserId(
    $privacyType: CollectionPrivacyType
    $userId: Int
  ) {
    getBookCollectionsByUserId(privacyType: $privacyType, userId: $userId) {
      id
      collectionName
      privacyType
      description
      books {
        id
        writer
        title
        coverImgPath
        penName {
          firstPenName
        }
      }
    }
  }
`
